import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLocalComponent } from './local/local.component';
import { UserDeptComponent } from './dept/dept.component';

const routes: Routes = [

  { path: 'local', component: UserLocalComponent },
  { path: 'dept', component: UserDeptComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
